(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multicolumn"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const chatNowLink = document.querySelector('a[title="embeddedMessagingConversationButton"');
    if (chatNowLink) {
      chatNowLink.addEventListener('click', (e) => {
        e.preventDefault();
        
        const embeddedChatButton = document.getElementById('embeddedMessagingConversationButton');
        if (embeddedChatButton) {
          embeddedChatButton.click();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
